// @flow
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import * as css from './Chart.scss';

type Props = {
	className?: string,
	type: string,
	rating: number,
};

const Chart = ({ className, type, rating }: Props) => {
	const [dashOffset, setDashOffset] = useState(0);
	const description = type === Chart.USERS_RAITING ? 'ציון הגולשים' : 'ציון המבקרים';

	useEffect(() => {
		// strokeDashoffset = 313 - 100% = 3.13
		const strokeDashoffset = 628 - 3.13 * rating;
		const timeout = setTimeout(() => {
			setDashOffset(strokeDashoffset);
		}, 500);

		return () => {
			clearTimeout(timeout);
		};
	}, [rating]);

	return (
		<div className={classNames(css.chart, css[type])}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.96 106.96">
				<path className={css.cls} d="M53.48,3.48a50,50,0,1,1-50,50A50,50,0,0,1,53.48,3.48Z" />
			</svg>

			<div className={css.fakeChart}>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 108">
					<circle cx="54" cy="54" r="50" style={{ strokeDashoffset: `${dashOffset}px` }} />
				</svg>
			</div>

			<div className={css.text}>
				<p className={css.percents}>{`${rating}`}</p>
				<p className={css.description}>{description}</p>
			</div>
		</div>
	);
};

Chart.USERS_RAITING = 'usersRating';
Chart.CRITICS_RAITING = 'criticsRating';

Chart.defaultProps = {
	className: '',
};

export default Chart;
